import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const GridContainer: React.FC<Props> = ({ children }: Props): JSX.Element => (
  <div
    className="grid gap-6"
    style={{
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(156px,100%), 1fr))',
    }}
    data-testid="GridContainer">
    {children}
  </div>
)

export default GridContainer
